const { getAxiosInstance } = require('../connection');

module.exports = {
    /**
     * Invites users to a new meeting
     * @param  {int} eventId
     * @param  {int} locationId
     * @param  {string} startTimestamp  Start timestamp, ISO8601
     * @param  {string} meetingName     Question text or "Meeting"
     * @param  {array} invitedUsers     List of user ids (int)
     * @param  {array} invitedSpeakers  List of speaker ids (int)
     * @param  {string} details         Note with the reason for the meeting, if needed
     * @param  {int} other.questionId         Optional. Question that started meetingName
     * @param  {int} other.rescheduleMeetingId  Optional. Id of the meeting to reschedule
     * @return {Promise}                Promise with answer from API
     */
    invite: function (eventId, locationId, startTimestamp, meetingName, invitedUsers, invitedSpeakers, details, other) {
        const { questionId, rescheduleMeetingId } = other,
            data = {
                event_id: eventId,
                location_id: locationId,
                start: startTimestamp,
                name: meetingName,
                invited_user_ids: invitedUsers,
                invited_speaker_ids: invitedSpeakers,
                details,
            };

        if (questionId) data.question_id = questionId;
        if (rescheduleMeetingId) data.reject_old_meeting = rescheduleMeetingId;

        return getAxiosInstance({
            url:  '/events/' + encodeURIComponent(eventId) + '/meetings',
            method: 'POST',
            json: true,
            data,
        }).then((response) => response.data);
    },
    block: function (eventId, startTimestamp, endTimestamp) {
        return getAxiosInstance({
            url:  '/events/' + encodeURIComponent(eventId) + '/meetings',
            method: 'POST',
            json: true,
            data: {
                event_id: eventId,
                start: startTimestamp,
                end: endTimestamp,
                invited_user_ids: [],
                invited_speaker_ids: [],
                blocked: true,
                name: 'meeting',
            },
        }).then((response) => response.data);
    },
    unblock: function (eventId, meetingId) {
        return getAxiosInstance({
            url:  '/events/' + encodeURIComponent(eventId) + '/meetings/' + encodeURIComponent(meetingId),
            method: 'DELETE',
            json: true,
        }).then((response) => response.data);
    },
    accept: function (userId, meetingId) {
        return getAxiosInstance({
            url:  '/users/' + encodeURIComponent(userId) + '/meetings/' + encodeURIComponent(meetingId),
            method: 'PUT',
            json: true,
            data: {
                user_id: userId,
                meeting_id: meetingId,
                reason: null,
                state: 'confirmed',
            },
        }).then((response) => response.data);
    },
    reject: function (userId, meetingId, reason, reasonText) {
        return getAxiosInstance({
            url:  '/users/' + encodeURIComponent(userId) + '/meetings/' + encodeURIComponent(meetingId),
            method: 'PUT',
            json: true,
            data: {
                user_id: userId,
                meeting_id: meetingId,
                reason,
                reason_text: reasonText,
                state: 'rejected',
            },
        }).then((response) => response.data);
    },
    checkAvailability: function (eventId, users, speakers) {
        let params = [];
        if (users && users.length) {
            params.push('users=' + users.join(','));
        }
        if (speakers && speakers.length) {
            params.push('speakers=' + speakers.join(','));
        }

        if (params.length) {
            params = '?' + params.join('&');
        } else {
            params = '';
        }

        return getAxiosInstance({
            url:  '/events/' + eventId + '/meetings/availability' + params,
            method: 'GET',
            json: true,
        }).then((response) => response.data);
    },
    REJECTION_REASONS: {
        UNAVAILABLE: 1,
        UNINTERESTED: 2,
        OTHER: 3,
    },
    batchUpdate: function (eventId, data) {
        // Data should match structure expected by the endpoint, see server side documentation

        return getAxiosInstance({
            url:  '/events/' + encodeURIComponent(eventId) + '/meetings/batch',
            method: 'POST',
            json: true,
            data: data,
        }).then((response) => response.data);
    },
};
